/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { AxiosHttpRequest } from './core/AxiosHttpRequest';

import { AuthApi } from './services/AuthApi';
import { ClientsApi } from './services/ClientsApi';
import { CodebookApi } from './services/CodebookApi';
import { CodebookEntryApi } from './services/CodebookEntryApi';
import { CodebookExitApi } from './services/CodebookExitApi';
import { CodebookWarehouseApi } from './services/CodebookWarehouseApi';
import { DeliveryApi } from './services/DeliveryApi';
import { DemandApi } from './services/DemandApi';
import { PriceListApi } from './services/PriceListApi';
import { ProductionProjectApi } from './services/ProductionProjectApi';
import { ProjectApi } from './services/ProjectApi';
import { UploadApi } from './services/UploadApi';
import { UserApi } from './services/UserApi';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class ClientApi {

  public readonly auth: AuthApi;
  public readonly clients: ClientsApi;
  public readonly codebook: CodebookApi;
  public readonly codebookEntry: CodebookEntryApi;
  public readonly codebookExit: CodebookExitApi;
  public readonly codebookWarehouse: CodebookWarehouseApi;
  public readonly delivery: DeliveryApi;
  public readonly demand: DemandApi;
  public readonly priceList: PriceListApi;
  public readonly productionProject: ProductionProjectApi;
  public readonly project: ProjectApi;
  public readonly upload: UploadApi;
  public readonly user: UserApi;

  public readonly request: BaseHttpRequest;

  constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = AxiosHttpRequest) {
    this.request = new HttpRequest({
      BASE: config?.BASE ?? '/api/v1',
      VERSION: config?.VERSION ?? '1.0.0',
      WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
      CREDENTIALS: config?.CREDENTIALS ?? 'include',
      TOKEN: config?.TOKEN,
      USERNAME: config?.USERNAME,
      PASSWORD: config?.PASSWORD,
      HEADERS: config?.HEADERS,
      ENCODE_PATH: config?.ENCODE_PATH,
    });

    this.auth = new AuthApi(this.request);
    this.clients = new ClientsApi(this.request);
    this.codebook = new CodebookApi(this.request);
    this.codebookEntry = new CodebookEntryApi(this.request);
    this.codebookExit = new CodebookExitApi(this.request);
    this.codebookWarehouse = new CodebookWarehouseApi(this.request);
    this.delivery = new DeliveryApi(this.request);
    this.demand = new DemandApi(this.request);
    this.priceList = new PriceListApi(this.request);
    this.productionProject = new ProductionProjectApi(this.request);
    this.project = new ProjectApi(this.request);
    this.upload = new UploadApi(this.request);
    this.user = new UserApi(this.request);
  }
}

